module.exports = __webpack_public_path__ + "img/main_ranking_2nd.f740593.png";